export const finishApiURl = {
  getList: "/finish",
  addFinish: "/finish/add",
  updateFinish: "/finish/update",
  updateStatus: "/finish/status",
};
